import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const CategoriesContent = lazy(() => import('../../components/Pages/Categories'));

export default function Categories() {
  document.title = `${process.env.REACT_APP_TITLE}: Tipping categories`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <CategoriesContent />
      </Suspense>
    </Layout>
  );
}
